module.exports = __webpack_public_path__ + "img/empty_list.5e015e39.png";